import mixpanelCl from '@src/telemetry/integrations/mixpanel'
import { deleteCookie, getCookie } from './index'

const isBrowser = typeof window !== `undefined`

export const setUser = user => {
  window.localStorage.setItem('gatsbyUser', JSON.stringify(user))
}

const getUser = () => {
  const userString = window.localStorage.getItem('gatsbyUser')
  if (userString) {
    const user = JSON.parse(userString)
    return user || {}
  }
  return {}
}

export const isLoggedIn = () => {
  if (!isBrowser) return false

  const refreshToken = getCookie('refresh_token')

  if (!refreshToken) {
    return false
  }

  const user = getUser()
  if (user) return !!user.email
}

export const getCurrentUser = () => isBrowser && getUser()

export const logout = callback => {
  if (!isBrowser) return
  setUser({})
  deleteCookie('refresh_token')
  deleteCookie('jwt_token_valid_checkout')
  mixpanelCl.reset()
  callback()
}

export const isGoogleSignInPrimary = () => {
  try {
    const { identities } = getCurrentUser()
    const signInIdentities = JSON.parse(identities || '[]')

    if (!Array.isArray(signInIdentities) || signInIdentities.length === 0) {
      return false
    }
    return signInIdentities.some(identity => identity?.providerType === 'Google' && identity?.primary)
  } catch (_error) {
    return false
  }
}

export const isAppleSignInPrimary = () => {
  try {
    const { identities } = getCurrentUser()
    const signInIdentities = JSON.parse(identities || '[]')

    if (!Array.isArray(signInIdentities) || signInIdentities.length === 0) {
      return false
    }
    return signInIdentities.some(identity => identity?.providerType === 'SignInWithApple' && !!identity?.primary)
  } catch (_error) {
    return false
  }
}
